/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Precheck_AbortInputs */

const en_subtitle_export_precheck_abort = /** @type {(inputs: Subtitle_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abort`)
};

const fr_subtitle_export_precheck_abort = /** @type {(inputs: Subtitle_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avorter`)
};

const de_subtitle_export_precheck_abort = /** @type {(inputs: Subtitle_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

const it_subtitle_export_precheck_abort = /** @type {(inputs: Subtitle_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aborto`)
};

const ru_subtitle_export_precheck_abort = /** @type {(inputs: Subtitle_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const es_subtitle_export_precheck_abort = /** @type {(inputs: Subtitle_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abortar`)
};

const zh_cn2_subtitle_export_precheck_abort = /** @type {(inputs: Subtitle_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中止`)
};

const ja_subtitle_export_precheck_abort = /** @type {(inputs: Subtitle_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アボート`)
};

const hi_subtitle_export_precheck_abort = /** @type {(inputs: Subtitle_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बीच में बंद करें`)
};

const pt_pt2_subtitle_export_precheck_abort = /** @type {(inputs: Subtitle_Export_Precheck_AbortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abortar`)
};

/**
* | output |
* | --- |
* | "Abort" |
*
* @param {Subtitle_Export_Precheck_AbortInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_precheck_abort = /** @type {((inputs?: Subtitle_Export_Precheck_AbortInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Precheck_AbortInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_precheck_abort(inputs)
	if (locale === "de") return de_subtitle_export_precheck_abort(inputs)
	if (locale === "it") return it_subtitle_export_precheck_abort(inputs)
	if (locale === "ru") return ru_subtitle_export_precheck_abort(inputs)
	if (locale === "es") return es_subtitle_export_precheck_abort(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_precheck_abort(inputs)
	if (locale === "ja") return ja_subtitle_export_precheck_abort(inputs)
	if (locale === "hi") return hi_subtitle_export_precheck_abort(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_precheck_abort(inputs)
	return en_subtitle_export_precheck_abort(inputs)
});